import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/services/shared-data.service';

@Component({
  selector: 'app-survey-closed',
  templateUrl: './survey-closed.component.html',
  styleUrls: ['./survey-closed.component.css']
})
export class SurveyClosedComponent {
  routeSubscription: Subscription | undefined;
  launchId: string = "";  
  responseId: string = "";  

  constructor(private route: ActivatedRoute,
              private sharedDataService: SharedDataService) { }
  ngOnDestroy(): void {
    this.routeSubscription != undefined ? this.routeSubscription.unsubscribe() : "";
  }

  ngOnInit(): void {}

}
